/**
 * 搜索组件
 * 包含高级模式
 */
// import Vue from 'vue'
import tabs from './src/main'

tabs.install = () => {
  // eslint-disable-next-line no-undef
  Vue.component(tabs.name, tabs)
}

export default tabs



// WEBPACK FOOTER //
// ./src/components/tabs/index.js